import { MODE_SLIDE_ACTIVE, PAGE_MODE_SLIDE } from '../actions/AutogeneratedAction'

function initialState() {
  return {
    isModeSlideActive: false,
    pageModeSlide: {
      numPages: 0,
      pageIndex: 0,
    },
  }
}

export default function autogenerated(state = initialState(), action) {
  switch (action.type) {
    case PAGE_MODE_SLIDE:
      return state ? { ...state, pageModeSlide: action.payload } : { pageModeSlide: action.payload }
    case MODE_SLIDE_ACTIVE:
      return state
        ? { ...state, isModeSlideActive: action.payload }
        : { isModeSlideActive: action.payload }
    default:
      return state
  }
}
